import React,{useEffect,useRef,useState} from 'react'
import './animal.css'
export default function Animal() {
    const aboutUsRef = useRef(null);
   
    useEffect(() => {
       
        window.scrollTo(0, 0);
      }, []);
      const [isExpanded, setIsExpanded] = useState(false);

      const handleToggle = () => {
        setIsExpanded(!isExpanded);
      };
  return (
    <div>
 <div className="image-section-ani first-section-ani">
                <div class="carousel-overlay-img"></div>
                <div className="animate one">
        <span>A</span><span>N</span><span>I</span><span>M</span><span>A</span><span>L</span> &nbsp;
        <span>P</span><span>R</span><span>O</span><span>T</span><span>E</span><span>C</span><span>T</span><span>I</span><span>O</span><span>N</span>
      </div>                 </div>
      <div className="container1">
      <div className="content1">
      <h1 className="report-title" style={{textAlign:'center'}}>Stray Animal Welfare & Protection Campaign </h1>
    <p className="report-organizer"><strong>Organized by:</strong> Indian Welfare Foundation</p>
      <p className="report-description">
      The Animal Protection Initiative by the Indian Welfare Foundation focuses on the welfare and safety of stray animals, ensuring they receive medical care, food, and protection from cruelty. This initiative aims to create a more compassionate environment for animals while promoting responsible pet care and community awareness.      </p>
      <p>Key Aspects of the Initiative:</p>
        <div>
          <br />
          <span id="text1" style={{ display: isExpanded ? 'block' : 'none' }}>
          <p className="report-description">
          1. Anti-Rabies Vaccination Drives – Conducting regular vaccination campaigns to prevent the spread of rabies and safeguard both animals and humans. (Example: Vaccinating nearly 45 stray dogs in Lakshmi Nagar, Bangalore.)      </p>

      <p className="report-description">
      2. Medical Treatment & Rescue Operations – Providing emergency medical assistance and treatment for injured, sick, or abandoned animals.      </p>
      <p className="report-description">
      3. Feeding Programs – Ensuring stray dogs and other animals receive regular food to prevent starvation and malnutrition.      </p>
      <p className="report-description">
      4. Awareness & Community Engagement – Educating the public about animal welfare, responsible pet ownership, and preventing cruelty against animals.      </p>
      <p className="report-description">
      5. Sterilization & Population Control – Working towards sterilization programs to humanely control the stray animal population and prevent overpopulation issues.</p>   
      <p className="report-description">
    Future Plans & Expansion Possibilities:
</p>

<p className="report-description">
    Collaboration with Veterinary Clinics to enhance medical care and treatment for stray animals.
</p>

<p className="report-description">
    Expanding Feeding Programs to more areas where stray animals struggle to find food.
</p>

<p className="report-description">
    Building an Animal Shelter for rescued and abandoned animals.
</p>

<p className="report-description">
    Stronger Advocacy for Animal Rights to ensure legal protection and better policies for animal welfare.
</p>
      
          <div className="grid-container-gly">
      
      <div className="grid-item-gly">
        <img src="https://indianwelfarefoundation11.s3.ap-south-1.amazonaws.com/IMG_20250129_111655.jpg" style={{height:250}} alt="Award 1" />
      </div>
      <div className="grid-item-gly">
        <img src="https://indianwelfarefoundation11.s3.ap-south-1.amazonaws.com/IMG_20250129_111730.jpg" style={{height:250}} alt="Award 2" />
      </div>
      <div className="grid-item-gly">
        <img src="https://indianwelfarefoundation11.s3.ap-south-1.amazonaws.com/IMG_20250129_111708.jpg" style={{height:250}} alt="Award 3" />
      </div>
      <div className="grid-item-gly">
        <img src="https://indianwelfarefoundation11.s3.ap-south-1.amazonaws.com/IMG_20250129_111643.jpg" style={{height:250}} alt="Award 4" />
      </div>
     
    
      </div>

          </span>
        </div>
        <div className="btn-container">
          <button id="toggle" onClick={handleToggle}>
            {isExpanded ? 'Read Less' : 'Read More'}
          </button>
        </div>
      </div>
    </div>
            <div ref={aboutUsRef} className="content-container">

                <div className="left-content" style={{ 
                    backgroundImage: 'url(data:image/jpeg;base64,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)', 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'center', 
                    backgroundRepeat: 'no-repeat', 
                    opacity: 0.8, 
                    padding: '20px', 
                    color: 'black' ,
                    borderRadius:'20px'
                }}>

                <p >The legal and ethical <span class="topic-highlight">protection of animals</span> has a long standing in the United States. Anticruelty statutes were enacted in some colonies before the Revolutionary War. More recently, animal protectionists have noted concern for the well-being of farm animals in confinement settings, especially since the publication of Ruth Harrison's Animal Machines in 1966. However, the principal focus of the recent animal rights movement has been to oppose the use of animals in product testing and biomedical research. The biomedical debate has become quite acrimonious, with some parties on both sides taking extreme positions. Few in ethics would deny that caregivers have ethical responsibilities to assure well-being of farm and food animals.</p>  </div>

                <div className="right-content-chi   .chi">

                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTob4WlsUKfUoaJN-G3KEUdUZ_wR6ib8qbaQg&s' alt="Right side image" />
                </div>
            </div>
    </div>
  )
}
